@let id = `filter-${filter().name}` | qpxKebabCase;

@if (expandedOptionsWithSave()) {
    <ng-container *ngTemplateOutlet="filterOptions" />
} @else {
    <button
        [id]="id"
        [attr.data-testid]="id"
        [attr.aria-label]="placeholder()"
        qpxButton="unstyled"
        matButton
        [size]="size()"
        [class]="allInputClasses()"
        [class.within-list]="isListLayout()"
        [matMenuTriggerFor]="menu"
        [disabled]="disabled() || !options().length"
    >
        @if (appliedAndSelectedCount() && counterWithPlaceholder()) {
            <span class="counter">{{ appliedAndSelectedCount() }} </span>
        }

        <span class="content">{{ triggerDisplayValue() }}</span>

        <div class="arrow">
            <ng-icon qpx name="lucideChevronDown" matButtonIcon />
        </div>
    </button>

    <mat-menu
        #menu="matMenu"
        xPosition="after"
        [aria-labelledby]="id"
        [class]="allPanelClasses()"
        (closed)="onDropdownClosed()"
    >
        <ng-container *ngTemplateOutlet="filterOptions" />
    </mat-menu>
}

<ng-template matMenuContent #filterOptions>
    @if (showHeader()) {
        <div
            class="dropdown-header"
            tabindex="-1"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
        >
            <div class="row">
                <!-- eslint-disable-next-line agentic/prefer-label-mat-label -->
                <mat-label class="font-semibold">
                    {{ selectedCount() }} selected
                </mat-label>
                <button
                    qpxButton
                    size="sm"
                    matButton="outlined"
                    [disabled]="!selectedCount()"
                    (click)="clearAll()"
                >
                    Clear All
                </button>
            </div>

            @if (enableSearch()) {
                <div
                    class="row"
                    tabindex="-1"
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                >
                    <mat-form-field
                        class="w-full"
                        qpxInput="search"
                        subscriptSizing="dynamic"
                    >
                        <ng-icon matPrefix qpx name="lucideSearch" />

                        <input
                            [id]="`${id}-search`"
                            type="text"
                            spellcheck="false"
                            autocomplete="off"
                            [placeholder]="searchPlaceholder()"
                            matInput
                            [formField]="searchField"
                        />

                        <button
                            matSuffix
                            qpxButton
                            matIconButton
                            aria-label="Clear"
                            [disabled]="!search().length"
                            [class.invisible]="!search().length"
                            (click)="clearSearch()"
                        >
                            <ng-icon qpx name="lucideX" />
                        </button>
                    </mat-form-field>
                </div>
            }
        </div>
    }

    <ul
        class="dropdown-options"
        tabindex="-1"
        [class.fullscreen]="expandedOptionsWithSave()"
        [class.with-search]="enableSearch()"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
    >
        @if (allOption(); as allOption) {
            <li>
                <mat-checkbox
                    qpx
                    [id]="`${id}-option-all`"
                    [checked]="isOptionSelected(allOption.id)"
                    (change)="onToggleAll($event.checked)"
                >
                    <span>{{ allOption.name }}</span>
                </mat-checkbox>
            </li>
        }

        @if (noneOption(); as noneOption) {
            <li>
                <mat-checkbox
                    qpx
                    [id]="`${id}-option-none`"
                    [checked]="isOptionSelected(noneOption.id)"
                    (change)="onToggleNone($event.checked)"
                >
                    <span>{{ noneOption.name }}</span>
                </mat-checkbox>
            </li>
        }

        @for (item of filteredOptions(); track item.id) {
            <li>
                <mat-checkbox
                    qpx
                    [id]="`${id}-option-${item.id}`"
                    [checked]="isOptionSelected(item.id)"
                    (change)="onToggleOrdinary(item.id, $event.checked)"
                >
                    {{ item.name }}
                </mat-checkbox>
            </li>
        }
    </ul>

    @if (!applyOnClose()) {
        <div
            class="dropdown-footer"
            tabindex="-1"
            [class.fullscreen]="expandedOptionsWithSave()"
            [class.with-search]="enableSearch()"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
        >
            @if (!expandedOptionsWithSave()) {
                <button
                    qpxButton
                    size="sm"
                    matButton="outlined"
                    (click)="applyFiltersAndCloseDropdown()"
                >
                    <ng-icon qpx name="lucideCheck" matButtonIcon />
                    <span>Apply</span>
                </button>
            } @else {
                <button
                    qpxButton
                    size="sm"
                    matButton="filled"
                    context="primary"
                    (click)="applyFiltersAndCloseDropdown()"
                >
                    <span>Save filters</span>
                </button>
            }
        </div>
    }
</ng-template>
